import { graphierQL } from 'utils'
import {
  GetTagsByidsQuery,
  GetTagsByidsQueryVariables
} from '~map-search/types/__generated/gql/graphql'

const getTagsByIds = async (ids) => {
  const response = await graphierQL<
    GetTagsByidsQuery,
    GetTagsByidsQueryVariables
  >({
    query: getTagsByIdsQuery,
    variables: {
      ids
    }
  })
  return response
}

const getTagsByIdsQuery = /* GraphQL */ `
  query GetTagsByids($ids: [ID!]) {
    getTagsByIds(ids: $ids) {
      id
      name
      count
      description
      type
    }
  }
`
export { getTagsByIds, getTagsByIdsQuery }
